document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const stickyQuantityInput = document.querySelector(".StickyQuantityInput");
    const stickyAddToCartBtn = document.getElementById("sticky-add-to-cart");
    const productQuantityInput = document.querySelector(
      ".ProductForm [name='quantity']"
    );
    const cartCountElement = document.querySelector(".Header__CartCount");
    const cartDotElement = document.querySelector(".Header__CartDot");

const productInfo = document.querySelector(".Product__Info");

const mainPriceElement = productInfo?.querySelector(".ProductMeta__Price");
const mainExcludingVATElement = productInfo?.querySelector(".excluding-vat");

    const stickyPriceElement = document.querySelector(".StickyProductPrice");
    const stickyExcludingVATElement = document.querySelector(
      ".StickyExcludingVAT"
    );

    if (!stickyQuantityInput || !stickyAddToCartBtn || !productQuantityInput) {
      console.error("Missing elements in Sticky CTA.");
      return;
    }

    // Copy product price & VAT-exclusive price to sticky CTA
    if (mainPriceElement && stickyPriceElement) {
      stickyPriceElement.innerHTML = mainPriceElement.innerHTML;
      console.log("Copied main price:", mainPriceElement.textContent.trim());
    } else {
      console.warn("Main price element not found.");
    }

    if (mainExcludingVATElement && stickyExcludingVATElement) {
      stickyExcludingVATElement.innerHTML = mainExcludingVATElement.innerHTML;
      console.log(
        "Copied excluding VAT price:",
        mainExcludingVATElement.textContent.trim()
      );
    } else {
      console.warn("No excluding VAT price found.");
    }

    // Event Listener for Quantity Buttons (Increase/Decrease)
    document.body.addEventListener("click", function (event) {
      if (event.target.matches("[data-action='sticky-increase-quantity']")) {
        event.preventDefault();
        event.stopPropagation();
        let currentValue = parseInt(stickyQuantityInput.value, 10) || 1;
        stickyQuantityInput.value = currentValue + 1;
        productQuantityInput.value = stickyQuantityInput.value;
        console.log(`Sticky Quantity increased: ${stickyQuantityInput.value}`);
      }

      if (event.target.matches("[data-action='sticky-decrease-quantity']")) {
        event.preventDefault();
        event.stopPropagation();
        let currentValue = parseInt(stickyQuantityInput.value, 10) || 1;
        if (currentValue > 1) {
          stickyQuantityInput.value = currentValue - 1;
          productQuantityInput.value = stickyQuantityInput.value;
          console.log(
            `Sticky Quantity decreased: ${stickyQuantityInput.value}`
          );
        }
      }
    });

    // Add to Cart Click
    stickyAddToCartBtn.addEventListener("click", function (event) {
      event.preventDefault();

      let productForm = document.querySelector(".ProductForm");

      if (!productForm) {
        console.error("Product form not found.");
        return;
      }

      let formData = new FormData(productForm);
      formData.set("quantity", stickyQuantityInput.value);

      console.log(`🛒 Adding ${stickyQuantityInput.value} item(s) to cart...`);

      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Added to cart:", data);
          updateCartCount();
          setTimeout(() => openCartDrawer(), 300);
          setTimeout(() => refreshCartDrawer(), 600);
        })
        .catch((error) => {
          console.error("Error adding to cart:", error);
        });
    });

    function updateCartCount() {
      fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          console.log("Updating cart count:", cart.item_count);

          if (cartCountElement) {
            cartCountElement.textContent = cart.item_count;
          }

          if (cartDotElement) {
            if (cart.item_count > 0) {
              cartDotElement.classList.add("is-visible");
            } else {
              cartDotElement.classList.remove("is-visible");
            }
          }
        })
        .catch((error) => {
          console.error("Error updating cart count:", error);
        });
    }

    function openCartDrawer() {
      let cartDrawer = document.getElementById("sidebar-cart");
      if (cartDrawer) {
        cartDrawer.setAttribute("aria-hidden", "false");
        document.body.classList.add("cart-open");

        let pageOverlay = document.querySelector(".PageOverlay");
        if (pageOverlay) {
          pageOverlay.classList.add("is-visible");
        }
      }
    }

    function refreshCartDrawer() {
      fetch("/cart.js?timestamp=" + new Date().getTime()) // Ensure fresh data
        .then((response) => response.json())
        .then((cart) => {
          console.log("Cart updated:", cart);

          if (cart.item_count > 0) {
            updateCartDrawer(cart);
          } else {
            console.warn("Cart is still empty.");
          }
        })
        .catch((error) =>
          console.error("Error refreshing cart drawer:", error)
        );
    }

    function updateCartDrawer(cart) {
      let cartDrawer = document.getElementById("sidebar-cart");

      if (!cartDrawer) {
        console.error("Cart drawer not found.");
        return;
      }

      fetch("/?sections=mini-cart")
        .then((response) => response.json())
        .then((data) => {
          let parser = new DOMParser();
          let newCartHTML = parser.parseFromString(
            data["mini-cart"],
            "text/html"
          );
          let updatedCartContent = newCartHTML.getElementById("sidebar-cart");

          if (updatedCartContent) {
            cartDrawer.innerHTML = updatedCartContent.innerHTML;
            console.log("Cart drawer updated successfully!");
            enableCartCloseEvents();
          } else {
            console.warn("Updated cart drawer content not found.");
          }
        })
        .catch((error) => console.error("Error updating cart drawer:", error));
    }

    function enableCartCloseEvents() {
      let cartDrawer = document.getElementById("sidebar-cart");
      let closeButton = cartDrawer?.querySelector(".Drawer__Close");
      let pageOverlay = document.querySelector(".PageOverlay");

      if (closeButton) {
        closeButton.addEventListener("click", function () {
          closeCartDrawer();
        });
      }

      if (pageOverlay) {
        pageOverlay.addEventListener("click", function () {
          closeCartDrawer();
        });
      }
    }

    function closeCartDrawer() {
      let cartDrawer = document.getElementById("sidebar-cart");
      if (cartDrawer) {
        cartDrawer.setAttribute("aria-hidden", "true");
        document.body.classList.remove("cart-open");

        let pageOverlay = document.querySelector(".PageOverlay");
        if (pageOverlay) {
          pageOverlay.classList.remove("is-visible");
        }
      }
    }

    enableCartCloseEvents();
  }, 1000);
});

 // PRODUCT PAGE
// product-meta
document.addEventListener('DOMContentLoaded', function() {
    const accordionHeaders = document.querySelectorAll('.accordion-header');

    accordionHeaders.forEach(header => {
        header.addEventListener('click', () => {
            const content = header.nextElementSibling;
            const icon = header.querySelector('.accordion-icon');

            content.classList.toggle('open');
            header.classList.toggle('open'); // For rotating the arrow
        });
    });
});
